import React, { useState, useEffect, useContext } from 'react';
import {
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	Button,
	Stack,
	TextField,
	Box
} from '@mui/material';
import { DataContext } from '../../../../context/DataContext';
import { getToken } from '../../../../api/Account';
import {
	getGestoresAsync,
	getGestoresBySucursalAccessAsync,
	getSucursalByUserAsync
} from '../../../../api/Users';
import { getRuta, simpleMessage } from '../../../../helpers/Helpers';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment/moment';
import { getLocalidadesAsync } from '../../../../api/Clients';
import { accionPrincipalSx } from '../../../../components/ui/accionPrincipal';

const SelectorCobroDiario = () => {
	const [gestorList, setGestorList] = useState([]);
	const [selectedFecha, setSelectedFecha] = useState(new Date());
	const [selectedGestor, setSelectedGestor] = useState('t');

	const [sucursalList, setSucursalList] = useState([]);
	const [selectedSucursal, setSelectedSucursal] = useState('t');

	// Localidad del cliente. "t" = todas. La lista sale de los datos ya capturados y no de
	// un catalogo, porque Localidad es un campo de texto libre del alta de cliente.
	const [localidadList, setLocalidadList] = useState([]);
	const [selectedLocalidad, setSelectedLocalidad] = useState('t');

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);
	let ruta = getRuta();
	const token = getToken();

	useEffect(() => {
		getGestores(selectedSucursal);
		getSucursals();
		getLocalidades();
	}, []);

	const getLocalidades = async () => {
		const result = await getLocalidadesAsync(token);
		if (!result.statusResponse) {
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setLocalidadList(result.data.result);
	};

	const verReport = () => {
		if (selectedGestor.length === 0) {
			simpleMessage('Seleccione un gestor', 'error');
			return;
		}
		if (!moment(selectedFecha).isValid()) {
			simpleMessage('Seleccione una fecha válida', 'error');
			return;
		}

		// La localidad se codifica: es texto libre y puede traer espacios o acentos.
		var params = `${selectedSucursal}/${selectedGestor}/${moment(selectedFecha).format(
			'YYYY-MM-DD'
		)}/${encodeURIComponent(selectedLocalidad)}`;
		window.open(`${ruta}/r-cobrodiario/${params}`);
	};

	const getSucursals = async () => {
		setIsLoading(true);
		const result = await getSucursalByUserAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		setSucursalList(result.data.result);
	};

	const onChangeSucursal = (value) => {
		setSelectedSucursal(value);
		getGestores(value);
	};

	const getGestores = async (sucursal) => {
		setIsLoading(true);
		const result =
			sucursal === 't'
				? await getGestoresBySucursalAccessAsync(token)
				: await getGestoresAsync(token, sucursal);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setIsLoading(false);
		setGestorList(result.data.result);
	};

	return (
		<div>
			<Box sx={{ width: '100%', maxWidth: 550 }}>
				<Stack spacing={2}>
					<FormControl fullWidth style={{ textAlign: 'left' }}>
						<InputLabel id="demo-simple-select-standard-label">Sucursal</InputLabel>
						<Select
							labelId="demo-simple-select-standard-label"
							id="demo-simple-select-standard"
							onChange={(e) => onChangeSucursal(e.target.value)}
							value={selectedSucursal}
							label="Sucursal"
						>
							{sucursalList.map((item) => {
								return (
									<MenuItem key={item.id} value={item.id}>
										{item.description}
									</MenuItem>
								);
							})}
							<MenuItem key={'t'} value={'t'}>
								TODAS...
							</MenuItem>
						</Select>
					</FormControl>

					<FormControl fullWidth style={{ textAlign: 'left', marginTop: 20 }}>
						<InputLabel id="demo-simple-select-standard-label">Gestores</InputLabel>
						<Select
							labelId="demo-simple-select-standard-label"
							id="demo-simple-select-standard"
							onChange={(e) => setSelectedGestor(e.target.value)}
							value={selectedGestor}
							label="Gestores"
							style={{ textAlign: 'left' }}
						>
							<MenuItem value="">
								<em>Seleccione un Gestor</em>
							</MenuItem>
							{gestorList.map((item) => {
								return (
									<MenuItem key={item.id} value={item.id}>
										{item.fullName}
									</MenuItem>
								);
							})}
							<MenuItem value={'t'}>TODOS...</MenuItem>
						</Select>
					</FormControl>

					<FormControl fullWidth style={{ textAlign: 'left' }}>
						<InputLabel id="cobrodiario-localidad">Localidad</InputLabel>
						<Select
							labelId="cobrodiario-localidad"
							onChange={(e) => setSelectedLocalidad(e.target.value)}
							value={selectedLocalidad}
							label="Localidad"
							style={{ textAlign: 'left' }}
						>
							<MenuItem value={'t'}>TODAS...</MenuItem>
							{localidadList.map((item) => {
								return (
									<MenuItem key={item} value={item}>
										{item}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>

					<DesktopDatePicker
						closeOnSelect
						label="Seleccione una fecha"
						inputFormat="DD/MM/YYYY"
						value={selectedFecha}
						onChange={(newValue) => setSelectedFecha(newValue)}
						renderInput={(params) => <TextField {...params} />}
					/>

					<Button
						variant="contained"
						startIcon={
							<FontAwesomeIcon icon={faPrint} />
						}
						onClick={() => verReport()}
						sx={accionPrincipalSx}
					>
						Generar Reporte
					</Button>
				</Stack>
			</Box>
		</div>
	);
};

export default SelectorCobroDiario;
